(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-tiktok-bestseller"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('#lp-tt');
    if (!root) return;
    document.body.classList.add('lp-tt-body');
    const count = root.querySelector('[data-lp-count]');
    const total = root.querySelector('[data-lp-total]');
    const money = (c) => (c / 100).toFixed(2).replace('.', ',') + ' €';
    const sync = (cart) => {
      count.textContent = cart.item_count;
      total.textContent = money(cart.total_price);
      root.classList.toggle('lp-tt--has-cart', cart.item_count > 0);
    };
    fetch('/cart.js').then((r) => r.json()).then(sync).catch(() => {});
    root.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-lp-variant]');
      if (chip) {
        const card = chip.closest('[data-lp-card]');
        card.querySelectorAll('[data-lp-variant]').forEach((c) => c.setAttribute('aria-pressed', 'false'));
        chip.setAttribute('aria-pressed', 'true');
        card.querySelector('[data-lp-add]').dataset.lpAdd = chip.dataset.lpVariant;
        return;
      }
      const btn = e.target.closest('[data-lp-add]');
      if (!btn || btn.disabled) return;
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Im Warenkorb ✓';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.lpAdd), quantity: 1 }] }) })
        .then((r) => r.json()).then(() => fetch('/cart.js')).then((r) => r.json()).then(sync)
        .catch(() => { btn.textContent = 'Nicht verfügbar'; })
        .finally(() => { setTimeout(() => { btn.disabled = false; btn.textContent = label; }, 1600); });
    });
    const onScroll = () => {
      const consent = document.getElementById('shopify-pc__banner');
      root.style.setProperty('--lp-consent', (consent ? consent.offsetHeight : 0) + 'px');
      root.classList.toggle('lp-tt--sticky', window.scrollY > window.innerHeight);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
